import { useIsMobileHook } from '@teliaee/telia-common-components';
import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Notice, Separator, Table } from 'telia-front-react';
import RoamingStore from '../../stores/RoamingStore';
import { getSubarrayOfResults } from '../../util/ObjectUtil';
import { VasNumber } from '../RoamingInterfaces';
import ShowMoreButton from './ShowMoreButton';
import {
  renderSpecialInformationDesktopTableHeading,
  renderSpecialInformationDesktopTableRow,
  renderSpecialInformationMobileTableRow
} from './SpecialAndEmergencyInformationTables';

interface SpecialNumbersProps {
  roamingStore?: RoamingStore;
}

const SpecialNumbers = (props: SpecialNumbersProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const { isMobile } = useIsMobileHook();
  const {
    roamingStore: {
      berecTable: { vasNumbers, numberOfVisibleResults, countryCode },
      selectedCountry
    }
  } = props;
  const visibleVasNumbers = getSubarrayOfResults(vasNumbers, numberOfVisibleResults.vasNumbers);
  const tableHeadingNumber = translate('roaming.specialInformation.tableHeading.number');
  const tableHeadingNameDescription = translate('roaming.specialInformation.tableHeading.nameDescription');
  const tableHeadingAdditionalInformation = translate('roaming.specialInformation.tableHeading.additionalInformation');

  const getTableRowValues = (info: VasNumber): { [key: string]: string } => ({
    [tableHeadingNumber]: info.vasNumberRange,
    [tableHeadingNameDescription]: info.nameDescription,
    [tableHeadingAdditionalInformation]: info.additionalInformation
  });

  return (
    <>
      <Notice size="small">
        {selectedCountry.name}: {translate('roaming.specialInformation.countryCode')} <b>+{countryCode}</b>
      </Notice>
      <Separator spacing="xsmall" color="invisible" />
      <Separator spacing="xxsmall" weight="thin" className="hidden-md hidden-lg hidden-xl" />
      {isMobile ? (
        <Table responsive="rows" break="md" className="text__margin-none">
          {visibleVasNumbers.map((info, index) => renderSpecialInformationMobileTableRow(`special-number-info-${index}`, index, getTableRowValues(info)))}
        </Table>
      ) : (
        <Table responsive="rows" className="text__margin-none">
          <thead>
            {renderSpecialInformationDesktopTableHeading(
              'special-numbers',
              [tableHeadingNumber, tableHeadingNameDescription, tableHeadingAdditionalInformation],
              4
            )}
          </thead>
          <tbody>
            {visibleVasNumbers.map((info, i) => renderSpecialInformationDesktopTableRow(`special-number-info-row${i}`, getTableRowValues(info), 4))}
          </tbody>
        </Table>
      )}
      <ShowMoreButton category="vasNumbers" />
    </>
  );
};

export default inject('roamingStore')(observer(SpecialNumbers));
